import { toast } from 'sonner';
import SitemapGenerator from '@/utils/sitemapGenerator';

export const useAutoSitemap = () => {
    const updateSitemapAndPing = async () => {
        try {
            const generator = new SitemapGenerator();
            
            // Генерируем новый sitemap
            const sitemap = await generator.updateSitemap();
            
            if (sitemap) {
                // Отправляем пинги поисковым системам
                const results = await generator.pingSearchEngines();
                
                const successful = results.filter(r => r.status === 'fulfilled' && r.value).length;
                const total = results.length;
                
                if (successful > 0) {
                    toast.success(`Sitemap обновлен и отправлен в ${successful}/${total} поисковых систем`);
                } else {
                    toast.warning('Sitemap обновлен, но возникли проблемы с отправкой в поисковые системы');
                }
                
                console.log('Sitemap updated and search engines notified');
            }
        } catch (error) {
            console.error('Error updating sitemap:', error);
            toast.error('Ошибка при обновлении sitemap');
        }
    };

    return { updateSitemapAndPing };
};
